var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"div",attrs:{"id":"ext-nav"},domProps:{"innerHTML":_vm._s(_vm.headerHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }